import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent } from './confirmDialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmDialogsService {

    constructor(private dialog: MatDialog) { }

    public confirm(title: string, message: string, confirmBtnTxt: string = 'Confirm', cancelBtnTxt: string = 'Cancel',
        buttonColorRevert: boolean = false, cancelReturnsFalse: boolean = false, footerText: string | null = null): Observable<boolean> {

        let dialogRef: MatDialogRef<ConfirmDialogComponent>;

        dialogRef = this.dialog.open(ConfirmDialogComponent, { autoFocus: !cancelReturnsFalse });
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;
        dialogRef.componentInstance.footer = footerText;
        dialogRef.componentInstance.confirmBtnTxt = confirmBtnTxt;
        dialogRef.componentInstance.cancelBtnTxt = cancelBtnTxt;
        dialogRef.componentInstance.buttonColorRevert = buttonColorRevert;
        dialogRef.componentInstance.cancelReturnsFalse = cancelReturnsFalse;

        return dialogRef.afterClosed();
    }

    public confirmRefactored(options: { title: string, message: string, confirmBtnTxt?: string, cancelBtnTxt?: string, footerText?: string, isDestructive?: boolean }): Observable<boolean> {

        const dialogRef: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, { autoFocus: false });
        dialogRef.componentInstance.title = options.title;
        dialogRef.componentInstance.message = options.message;
        dialogRef.componentInstance.footer = options.footerText ?? null;
        dialogRef.componentInstance.confirmBtnTxt = options.confirmBtnTxt ?? "Confirm";
        dialogRef.componentInstance.cancelBtnTxt = options.cancelBtnTxt ?? "Cancel";
        dialogRef.componentInstance.buttonColorRevert = !!options.isDestructive ? !options.isDestructive : true;

        dialogRef.componentInstance.reverseButtonDirection = true;
        dialogRef.componentInstance.cancelReturnsFalse = true;

        return dialogRef.afterClosed();
    }

    public confirmSingleButton(title: string, message: string, confirmBtnTxt: string = 'Confirm',
        buttonColorRevert: boolean = false, isMobile: boolean = false, customHtml: string | null = null): Observable<boolean> {
        let dialogRef: MatDialogRef<ConfirmDialogComponent>;
        dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                hideCancelButton: true,
                isMobile: isMobile
            },
            maxWidth: isMobile ? "95%" : undefined,
            width: customHtml && !isMobile ? "50%" : isMobile ? "95%" : undefined,
            autoFocus: isMobile ? false : undefined,
        });
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;
        dialogRef.componentInstance.confirmBtnTxt = confirmBtnTxt;
        dialogRef.componentInstance.buttonColorRevert = buttonColorRevert;

        if(customHtml){
            dialogRef.componentInstance.customHtml = customHtml;
        }

        return dialogRef.afterClosed();
    }
}
